var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tr-rep__container" },
    [
      _c(
        "div",
        { staticClass: "tr-rep__header" },
        [
          _c("div", { staticClass: "tr-rep__title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("tenancy.representative.title")) +
                " (" +
                _vm._s(_vm.$t("handover.internalUseOnly")) +
                ")\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.hasUpdateTrRepAccess
            ? _c("FormActionBtns", {
                attrs: {
                  disableEdit: _vm.isTrEditing,
                  hiddenAdd: true,
                  onCancel: _vm.cancel,
                  onSave: _vm.save,
                },
                model: {
                  value: _vm.modeStatus,
                  callback: function ($$v) {
                    _vm.modeStatus = $$v
                  },
                  expression: "modeStatus",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isEditing
        ? _c("ViewVue")
        : _c("EditVue", {
            attrs: { trReps: _vm.trRepAccounts },
            on: {
              "update:trReps": function ($event) {
                _vm.trRepAccounts = $event
              },
              "update:tr-reps": function ($event) {
                _vm.trRepAccounts = $event
              },
            },
          }),
      _vm._v(" "),
      _c("HKLInviteModal", {
        ref: "inviteAllRef",
        attrs: {
          listTitle: _vm.$t("tenancy.representative.title"),
          accountsList: _vm.needInviteAccounts,
        },
        on: {
          onInviteClick: function () {
            return _vm.inviteAll(_vm.needInviteAccounts)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }